import type { SelectedFile } from '@witmetrics/utils';
import { formatFileSize } from '@witmetrics/utils/strings';
import Title from '@/components/Title';
import { CloseIcon } from '@/icons';
import type { SvgIconProps } from '@/icons/types';
import FileCategoryIcon from '@/components/FileCategoryIcon';
import { classes } from './utils';

export type FileSelectionProps = {
  title: string;
  subtitle: string;
  selectedFile: SelectedFile;
  onRemove: (selectedFile: SelectedFile) => void;
};

export default function FileSelection({
  title,
  subtitle,
  selectedFile,
  onRemove,
}: FileSelectionProps) {
  // TODO: Render multiple files(?)

  const handleRemove: SvgIconProps['onClick'] = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onRemove(selectedFile);
  };

  return (
    <div className={classes.wrapper}>
      <CloseIcon className={classes.closeIcon} onClick={handleRemove} />
      {selectedFile.previewSource ? (
        <div className={classes.imgWrapper}>
          <img
            className={classes.img}
            alt={selectedFile.file.name}
            src={selectedFile.previewSource}
          />
        </div>
      ) : (
        <FileCategoryIcon
          file={{ name: selectedFile.file.name, fileTypeId: null }}
        />
      )}
      <div className={classes.content}>
        <Title className={classes.title} size="xs">
          {`${title} ${subtitle}`}
        </Title>
        <Title className={classes.fileName} size="xs">
          {selectedFile.file.name}
        </Title>
        <div className={classes.subtitle}>
          {formatFileSize(selectedFile.file.size)}
        </div>
      </div>
    </div>
  );
}
